/** Tipos de revista (parceiro + Partiu). */
export const MAGAZINE_TYPES = ['magazine', 'magazine-partiu'] as const;

export function isMagazineType(type?: string | null): boolean {
  return type === 'magazine' || type === 'magazine-partiu';
}
